<template>
  <div>
     <!-- Skeleton -->
     <div v-if="isLoadingData" class="detail-product-card">
      <div class="flex-column gap-label">
        <div class="flex-column" v-for="n in 4" :key="n">
          <div class="skeleton skeleton-label" />
          <div class="skeleton skeleton-value" />
        </div>
        <div class="button-container">
          <div class="skeleton skeleton-button" />
        </div>
      </div>
    </div>

    <!-- Konten jika data sudah ada -->
    <div v-else class="detail-product-card" >
      <div class="flex-column gap-label">
        <div
          v-for="(label, key) in detailItems"
          :key="key"
          class="flex-column"
          v-if="data[key] !== null && data[key] !== undefined && data[key] !== ''"
        >
          <span class="text-label" v-html="label"></span>
          <span class="text-value">
            <template v-if="key === 'min_initial_deposit'">
              {{ $formatRupiah(data[key]) }}
            </template>
            <template v-else-if="key === 'equal_rate'">
              {{ $formatPersen(data[key]) }}% p.a.
            </template>
            <template v-else>
              {{ getVal(data[key].name || data[key]) }}
            </template>
          </span>
        </div>
        <div class="button-container">
          <button class="button-blue" @click.prevent="clickPengajuan" v-if="showAjukanSekarang" :disabled="isLoading">
            <template v-if="isLoading">
              <b-spinner small type="border" variant="light" class="mr-2" label="Memproses..."></b-spinner>
              Memproses...
            </template>
            <template v-else>
              Ajukan Sekarang
            </template>
          </button>
        </div>
      </div>
    </div>
    <!-- modal pengajuan -->
    <newCustomModal :visible="showPengajuanModal" @close="closeModalProperly">
      <div class="flex-column" style="align-items: center; justify-content: center; text-align: center;">
        <img :src="require(`@/assets/images/landing_page/logo-efunding.svg`)" alt="logo" width="350">
        <span class="title-modal" style="font-weight: 700; margin-top: 20px; font-size: 30px; margin-bottom: 10px;">Konfirmasi Setoran Awal</span>
        <span class="text-value" style="color: #274C8E;">Nominal Setoran Awal <strong>{{ data && data.nama_produk ? data.nama_produk : '-' }}</strong><br> Minimal Adalah <strong>{{ $formatRupiah(data.min_initial_deposit) }}</strong></span>
        <input
          type="text"
          class="input-style"
          :placeholder="`Masukkan Nominal Setoran Awal ${data && data.nama_produk ? data.nama_produk : '-'}`"
          v-model="minDeposit"
          @input="onMinDepositInput"
        />
        <p v-if="isMinDepositInvalid" class="error-text">
          Nominal setoran harus lebih besar atau sama dengan {{ $formatRupiah(data.min_initial_deposit || 0) }}
        </p>
        <!-- <span v-if="referalInput" class="text-value" style="color: #274C8E; margin-top: 20px;">Kode Referal</span>
        <input v-if="referalInput"
          type="text"
          class="input-style"
          :placeholder="`Masukkan Kode Referal (Opsional)`"
          v-model="form.referral_code"
          @input="onReferalInput"
        /> -->
        <div class="modal-action-buttons no-rekening">
          <button class="custom-btn danger" @click="closeModalProperly">Batal</button>
          <button class="custom-btn primary" @click="onAddSetoran">Ajukan</button>
        </div>
      </div>
    </newCustomModal>

    <!-- syarat ketentuan -->
    <newCustomModal :visible="showTermsModal" @close="closeModalProperly" :term="true">
      <div
        ref="termsPengajuanContent"
        class="scroll-wrapper"
        @scroll.passive="handleScroll"
        @touchmove.passive="handleScroll"
        style="max-height: 500px; overflow-y: scroll;"
      >
        <TermsPengajuanContent />
      </div>

      <div class="tooltip-wrapper" :class="{ 'show-tooltip': !hasScrolledToBottom && !hasAcceptedTerms }">
        <button
          class="custom-btn-modal mt-3"
          :disabled="!hasScrolledToBottom && !hasAcceptedTerms"
          @click="hasAcceptedTerms ? cancelTerms() : acceptTerms()"
        >
          {{ hasAcceptedTerms ? 'Batal Setuju' : 'Setuju dan Lanjutkan' }}
        </button>
        <span class="tooltip-text">Harap scroll untuk menyetujui</span>
      </div>
    </newCustomModal>


    <!-- confirm pengajuan -->
    <newCustomModal :visible="confirmPengajuanModal">
      <div class="flex-column" style="align-items: center; justify-content: center; text-align: center;">
        <img :src="require(`@/assets/images/landing_page/logo-efunding.svg`)" alt="logo" width="350">

        <span class="title-modal" style="font-weight: 700; margin-top: 20px; font-size: 30px;">Konfirmasi Pengajuan</span>

        <div
          style="background-color: #f2f2f2; padding: 20px; border-radius: 10px; margin-top: 30px; width: 100%; max-width: 500px;"
        >
          <div class="text-value" style="color: #274C8E;">
            Apakah Anda Yakin untuk melakukan
          </div>
          <div class="text-value" style="color: #274C8E;">
            Pengajuan <strong>{{ data && data.nama_produk ? data.nama_produk : '-' }}</strong> ?
          </div>
          <div class="text-value" style="color: #274C8E; margin-top: 20px;">
            Nominal Setoran Awal Yang Anda Ajukan
            <br>
            <strong>{{ $formatRupiah(form.deposit) }}</strong>
          </div>
          <template v-if="form.nominalTabungan != null">
            <hr style="border: none; border-top: 1px solid #ccc; margin: 25px 0;" />
            <div class="text-value" style="color: #274C8E;">
              Nominal Setoran Awal Untuk
              <strong>{{ productTabungan && productTabungan.nama_produk ? productTabungan.nama_produk : '-' }}</strong>
            </div>
            <div class="text-value" style="color: #274C8E;">
              <strong>{{ $formatRupiah(form.nominalTabungan) }}</strong>
            </div>
          </template>
          <template v-if="form.nomorRekening != null">
            <hr style="border: none; border-top: 1px solid #ccc; margin: 25px 0;" />
            <div class="text-value" style="color: #274C8E;">
              Nomor Rekening <strong>{{ productTabungan && productTabungan.nama_produk ? productTabungan.nama_produk : '-' }}</strong>
            </div>
            <div class="text-value" style="color: #274C8E; text-decoration: underline;">
              <strong>{{ form.nomorRekening || '-' }}</strong>
            </div>
          </template>
          <!-- <template v-if="form.referral_code != null">
            <hr style="border: none; border-top: 1px solid #ccc; margin: 25px 0;" />
            <div class="text-value" style="color: #274C8E;">
              Kode Referal
            </div>
            <div class="text-value" style="color: #274C8E; text-decoration: underline;">
              <strong>{{ form.referral_code || '-' }}</strong>
            </div>
          </template> -->
        </div>

        <div class="modal-action-buttons no-rekening">
          <button class="custom-btn danger" @click="onCloseConfirmPengajuan" :disabled="isLoading">Batal</button>
          <button class="custom-btn primary d-flex align-items-center justify-content-center" @click="onProsesPengajuan" :disabled="isLoading">
            <template v-if="isLoading">
              <b-spinner small type="border" variant="light" class="mr-2" label="Memproses..."></b-spinner>
              Memproses...
            </template>
            <template v-else>
              Ya, Ajukan
            </template>
          </button>
        </div>
      </div>
    </newCustomModal>

    <!-- confirm success pengajuan -->
    <newCustomModal :visible="successPengajuanModal" size="medium">
      <div class="flex-column" style="align-items: center; justify-content: center; text-align: center;">
        <img :src="require(`@/assets/images/success-icon.png`)" alt="logo" width="200">
        <span class="title-modal" style="font-weight: 700; margin-top: 20px; font-size: 30px; margin-bottom: 40px;">Pengajuan Berhasil</span>
        <div
          style="background-color: #f2f2f2; padding: 20px; border-radius: 10px; width: 100%; max-width: 500px;"
        >
          <span class="text-value" style="color: #274C8E;">Anda memiliki dokumen yang perlu ditandatangani untuk menyelesaikan proses ini. Harap segera melakukan tanda tangan elektronik.</span>
        </div>
        <div class="modal-action-buttons no-rekening">
          <button class="custom-btn danger" @click="closeModalProperly" :disabled="isLoading">
            Tutup
          </button>

          <button
            class="custom-btn primary d-flex align-items-center justify-content-center"
            @click="goToSignaturePage"
            :disabled="isLoading"
          >
            <template v-if="isLoading">
              <b-spinner small type="border" variant="light" class="mr-2" label="Loading..."></b-spinner>
              Memproses...
            </template>
            <template v-else>
              Tandatangani Dokumen
            </template>
          </button>
        </div>
      </div>
    </newCustomModal>

    <!-- confirm wrong pengajuan -->
    <newCustomModal :visible="errorPengajuanModal" size="medium">
      <div class="flex-column" style="align-items: center; justify-content: center; text-align: center;">
        <img :src="require(`@/assets/images/wrong-icon.png`)" alt="logo" width="200">
        <span class="title-modal" style="font-weight: 700; margin-top: 20px; font-size: 30px; margin-bottom: 40px; color: red;">Pengajuan Gagal</span>
        <div
          style="background-color: #f2f2f2; padding: 20px; border-radius: 10px; width: 100%; max-width: 500px;"
        >
          <span class="text-value" style="color: red;">{{ messageWrong }}</span>
        </div>
        <div class="modal-action-buttons wrong-modal">
          <button class="custom-btn danger" @click="closeModalProperly" :disabled="isLoading">Tutup</button>
        </div>
      </div>
    </newCustomModal>
    <!-- rejection block modal -->
    <newCustomModal :visible="rejectionBlockModal" @close="rejectionBlockModal = false" size="medium">
      <div class="flex-column" style="align-items: center; justify-content: center; text-align: center;">
        <b-icon icon="exclamation-octagon-fill" variant="danger" style="width: 80px; height: 80px;" class="mb-3"></b-icon>
        <span class="title-modal" style="font-weight: 700; font-size: 24px; margin-bottom: 10px;">Pengajuan Ditangguhkan</span>
        <p class="text-muted">Mohon maaf, Anda belum dapat melakukan pengajuan baru karena terdapat pengajuan sebelumnya yang memerlukan <strong>perbaikan data profil</strong>.</p>
        
        <div v-if="activeRejectionFields.length > 0" class="w-100 text-left bg-light p-3 rounded mb-3" style="border: 1px solid #ddd;">
          <p class="mb-2 font-weight-bold"><b-icon icon="list-check" class="mr-1"></b-icon> Data atau informasi yang memerlukan perbaikan::</p>
          <div class="d-flex flex-wrap">
            <b-badge v-for="(field, index) in activeRejectionFields" :key="index" variant="warning" class="mr-1 mb-1 p-2 text-dark border border-dark">
              {{ formatFieldLabel(field) }}
            </b-badge>
          </div>
        </div>
        
        <p class="mb-4">Silahkan perbarui data profil Anda terlebih dahulu sebelum melakukan pengajuan kembali.</p>
        
        <div class="modal-action-buttons no-rekening w-100">
          <button class="custom-btn danger" @click="rejectionBlockModal = false">Tutup</button>
          <button class="custom-btn primary" @click="$router.push('/pengajuan-saya?q=Profil')">Perbarui Profil Sekarang</button>
        </div>
      </div>
    </newCustomModal>


  </div>
</template>

<script>
import newCustomModal from "../../components/newCustomModal.vue"
import pengajuan from "../../api/pengajuan";
import Product from "../../api/produk";
import Funder from "../../api/funder";
import TermsPengajuanContent from "../../components/TermsPengajuanContent.vue"

export default {
  name: "CardInfoDeposito",
  components: {
    newCustomModal,
    TermsPengajuanContent
  },
  props: {
    data: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data(){
    return{
      // modals
      showPengajuanModal: false,
      kepemilikanRekeningModal: false,
      dontHaveRekeningModal: false,
      showTermsModal: false,
      confirmPengajuanModal: false,
      successPengajuanModal: false,
      errorPengajuanModal: false,
      rejectionBlockModal: false,
      activeRejectionFields: [],

      // form
      form:{
        deposit: null,
        nominalTabungan: null,
        nomorRekening: null,
        referral_code: null,
      },

      // variable
      minDeposit: null,
      setoranTabungan: null,
      messageWrong: null,
      pengajuan_id: null,
      detailItems: {
        nama_produk: 'Tabungan Ukhuwah',
        akad: 'Jenis Akad',
        min_initial_deposit: 'Nilai Simpanan Minimal',
        nisbah: 'Nisbah',
        equal_rate: 'Proyeksi Bagi Hasil<br>(Equal Rate)'
      },


      // validation
      isMinDepositInvalid: false,
      currentUser: null,
      productTabungan: null,
      minSetoranTabungan: null,
      isHaveRekeningModal: false,
      isMinDepositInvalid2: false,
      hasScrolledToBottom: false,
      hasAcceptedTerms: false, 
      isLoading: false,
      isLoadingData: true,
      referalInput: false,
    }
  },
  watch: {
    data: {
      handler(newVal) {
        if (newVal) {
          this.isLoadingData = false; 
        }
      },
      immediate: true, 
      deep: true
    }
  },
  created(){
    this.currentUser = this.$store.state.auth.user || null;
  },  
  mounted(){
    window.addEventListener('beforeunload', this.preventReloadOnConfirm);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.preventReloadOnConfirm);
  },
  computed: {
    showAjukanSekarang() {
      if (!this.currentUser || !this.currentUser.info) {
        return true;
      }
      return this.currentUser.info.role_id !== 5 && this.currentUser.info.role_id !== 6;
    }
  },
  methods: {
    onReferalInput(e) {
      let value = e.target.value;

      // 1. Hilangkan karakter selain huruf & angka
      value = value.replace(/[^a-zA-Z0-9]/g, '');

      // 2. Ubah huruf jadi huruf besar
      value = value.toUpperCase();

      // 3. Batasi maksimal 6 karakter
      value = value.slice(0, 6);

      // 4. Set kembali ke form
      this.form.referral_code = value;
    },
    getVal(value) {
      return value !== null && value !== undefined && value !== '' ? value : '-';
    },
    preventReloadOnConfirm(event) {
      if (this.isLoading) {
        event.preventDefault();
        event.returnValue = ''; 
        return '';
      }
    },
    acceptTerms() {
      this.hasAcceptedTerms = true;
      this.showTermsModal = false;
      this.confirmPengajuanModal = true;
      this.showPengajuanModal = false
    },
    cancelTerms() {
      this.hasAcceptedTerms = false;
      this.showTermsModal = false;
    },
    handleScroll() {
      const el = this.$refs.termsPengajuanContent;
      console.log("ScrollTop:", el.scrollTop, "ClientHeight:", el.clientHeight, "ScrollHeight:", el.scrollHeight);
      
      const threshold = 5;
      this.hasScrolledToBottom =
        el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;
    },
    formatRupiah(angka) {
      return angka.toLocaleString("id-ID");
    },
    formatRupiahValue(value) {
      if (value == null || value === '') return '';

      let number;

      if (typeof value === 'number') {
        number = value;
      } else {
        const cleaned = value
          .toString()
          .replace(/[^0-9,\.]/g, '')
          .replace(',', '.');

        number = parseFloat(cleaned);
      }

      if (isNaN(number)) return '';

      const rounded = Math.round(number);

      return 'Rp ' + rounded.toLocaleString('id-ID');
    },
    parseRupiahToNumber(val) {
      return Number(val.replace(/[^\d]/g, ''));
    },
    onMinDepositInput() {
      const value = this.parseRupiahToNumber(this.minDeposit);
      const minRequired = this.data.min_initial_deposit || 0;
      this.form.deposit = value;
      this.minDeposit = this.formatRupiahValue(value);
      this.isMinDepositInvalid = value < minRequired;
    },
    async onProsesPengajuan() {
      this.isLoading = true;

      if (!this.currentUser) {
        this.confirmPengajuanModal = false;
        this.$toast.error("Anda Belum Login!");
        this.$router.push('/login');
        this.isLoading = false;
        return;
      }

      if (this.form.deposit == null) {
        this.$toast.error("Harap Isikan Nominal Deposito!");
        this.isLoading = false;
        return;
      }

      if (this.form.deposit < this.data.min_initial_deposit) {
        this.$toast.error("Nominal Deposito Kurang Dari Minimal Deposito Produk!");
        this.isLoading = false;
        return;
      }

      try {
        const payload = {
          product_id: this.data.id,
          setoran_awal: this.form.deposit,
          referal_code: this.form.referral_code || null,
        };

         await pengajuan.store(payload)
          .then((res)=>{
            const code = res.data.meta.code;
            if (code === 200) {
              const data = res.data.data;

              this.pengajuan_id = Array.isArray(data)
                ? data[0].id
                : data.id;

              this.confirmPengajuanModal = false;
              this.successPengajuanModal = true;
            } else if (code === 403 && res.data.data && res.data.data.rejected_fields) {
              this.confirmPengajuanModal = false;
              this.activeRejectionFields = res.data.data.rejected_fields;
              this.rejectionBlockModal = true;
            } else if ([409, 403, 422, 500].includes(code)) {
              this.confirmPengajuanModal = false;
              this.errorPengajuanModal = true;
              this.messageWrong = res.data.meta.message || 'Terjadi Kesalahan Pada Server';
            }

            this.isLoading = false;
            })
      } catch (error) {
        console.error("Terjadi error saat pengajuan:", error);
        this.errorPengajuanModal = true;
        this.messageWrong = "Terjadi kesalahan saat memproses pengajuan.";
      } finally {
        this.isLoading = false;
      }
    },
    goToSignaturePage(){
      this.isLoading = true;
      this.successPengajuanModal = true;
      const pengajuanId = this.pengajuan_id;
      if (pengajuanId) {
        this.$router.push({
          path: '/pengajuan-saya',
          query: {
            pengajuan_id: pengajuanId,
            action: 'show'
          }
        });
        this.isLoading = false;
      } else {
        this.$toast.error("Terjadi Kesalahan");
        console.error("Gagal mendapatkan pengajuan ID", pengajuanId);
        this.isLoading = false;
      }
      this.isLoading = false;
    },
    async clickPengajuan() {
      if (!this.currentUser) {
        this.$toast.error("Anda Belum Login!");
        return;
      } else if (this.currentUser.info.agen_id == null ) {
        this.referalInput = true;
      } 

      this.isLoading = true; 

      try {
        // 1. Check for unresolved rejections using the check-rejection endpoint.
        // Dibungkus try/catch sendiri supaya jika endpoint ini bermasalah, alur
        // pengajuan tetap bisa lanjut (tidak ikut memblokir seperti sebelumnya).
        try {
          const resReject = await pengajuan.checkRejection();
          const rejectData = resReject.data.data;
          if (resReject.data.meta.code === 200 && rejectData.has_rejection && !rejectData.is_fully_resolved) {
            this.activeRejectionFields = rejectData.unresolved_fields || [];
            this.rejectionBlockModal = true;
            this.isLoading = false;
            return;
          }
        } catch (rejectError) {
          console.error("Gagal mengecek status penolakan:", rejectError);
        }

        // Lanjut ke pengecekan kelengkapan profil jika tidak ada bloking penolakan
        const resComplete = await pengajuan.isFunderCompleteProfile();
        if (resComplete.data.meta.code === 200) {
          if (this.data.syarat_kepemilikan_rekening === true) {
            this.kepemilikanRekeningModal = true;
          } else {
            this.showPengajuanModal = true;
          }
        } else if (resComplete.data.meta.code === 204 || resComplete.data.meta.code === 206){
          this.$toast.error(resComplete.data.meta.message);
          this.$router.push('/pengajuan-saya');
        } else if ([403, 401, 400].includes(resComplete.data.meta.code)){
          this.$toast.error(resComplete.data.meta.message);
        } 
      } catch (error) {
        console.error("Error in clickPengajuan:", error);
        this.$toast.error("Terjadi kesalahan saat memproses pengajuan.");
      } finally {
        this.isLoading = false;
      }
    },
    onAddSetoran() {
      if (!this.currentUser) {
        this.showPengajuanModal = false;
        this.$toast.error("Anda Belum Login!");
        this.$router.push('/login');
        return;
      }

      if (this.form.deposit == null) {
        this.$toast.error("Harap Isikan Nominal Deposito!");
        return;
      }

      if (this.form.deposit < this.data.min_initial_deposit) {
        this.$toast.error("Nominal Deposito Kurang Dari Minimal Deposito Produk!");
        return;
      }


      this.showTermsModal = true;
      this.$nextTick(() => {
        const el = this.$refs.termsPengajuanContent;
        if (el) {
          el.scrollTop = 0; // Reset posisi scroll ke atas
          this.hasScrolledToBottom = false; // Reset status scroll
        }
      });
    },
    onCloseConfirmPengajuan(){
      this.confirmPengajuanModal = false;
      this.showPengajuanModal = true;
      this.hasAcceptedTerms = null;
    },
    closeModalProperly() {
      this.showPengajuanModal = false;
      this.confirmPengajuanModal = false;
      this.successPengajuanModal = false;
      this.errorPengajuanModal = false;

      this.minDeposit = null;
      this.isMinDepositInvalid = false;
      this.setoranTabungan = null;
      this.isMinDepositInvalid2 = false;
      this.form.deposit = null;
      this.showTermsModal = false;
      this.hasAcceptedTerms = false;

      this.$nextTick(() => {
        this.showPengajuanModal = false; 
      });
    },
    formatFieldLabel(f) {
      if (!f) return '';
      const fieldName = typeof f === 'object' ? f.field : f;
      if (!fieldName) return '';
      const fieldKey = String(fieldName).toLowerCase().replace(/ /g, '_');
      
      // Special Mappings
      if (fieldKey.includes('nama_pihak_terkait') || fieldKey.includes('related_party_name')) return 'NAMA AHLI WARIS';
      if (fieldKey.includes('hubungan_pihak_terkait') || fieldKey.includes('related_party_relationship')) return 'HUBUNGAN AHLI WARIS';
      if (fieldKey.includes('no_hp_pihak_terkait') || fieldKey.includes('related_party_phone')) return 'NOMOR TELEPON AHLI WARIS';
      if (fieldKey.includes('alamat_pihak_terkait') || fieldKey.includes('related_party_address')) return 'ALAMAT AHLI WARIS';
      if (fieldKey === 'pihak_terkait') return 'AHLI WARIS';
      
      if (fieldKey === 'npwp_attachment' || fieldKey === 'taxpayer_document_path') return 'NPWP GAMBAR / PDF';
      if (fieldKey === 'alamat_terkini' || fieldKey === 'current_address') return 'ALAMAT DOMISILI';
      if (fieldKey === 'ratarata_penghasilan_perbulan' || fieldKey === 'estimated_transaction_value') return 'RATA-RATA PENGHASILAN DALAM 1 BULAN';
      if (fieldKey === 'nama_tempatkerja' || fieldKey === 'company_name') return 'NAMA TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'alamat_tempatkerja' || fieldKey === 'company_address') return 'ALAMAT TEMPAT KERJA / PERUSAHAAN';
      if (fieldKey === 'jabatan' || fieldKey === 'position_id') return 'JABATAN';
      if (fieldKey === 'bank_id' || fieldKey === 'bank') return 'NAMA BANK';
      if (fieldKey === 'account_number') return 'NOMOR REKENING';
      if (fieldKey === 'account_name') return 'NAMA PEMILIK REKENING';
      if (fieldKey === 'taxpayer_number' || fieldKey === 'npwp') return 'NPWP';
      if (fieldKey === 'identity_number') return 'NOMOR IDENTITAS / KTP';
      if (fieldKey === 'gender' || fieldKey === 'jenis_kelamin') return 'JENIS KELAMIN';
      if (fieldKey === 'identity_address' || fieldKey === 'alamat') return 'ALAMAT KTP';
      if (fieldKey === 'place_of_birth' || fieldKey === 'tempat_lahir') return 'TEMPAT LAHIR';
      if (fieldKey === 'date_of_birth' || fieldKey === 'tanggal_lahir') return 'TANGGAL LAHIR';
      if (fieldKey === 'nationality' || fieldKey === 'kewarganegaraan') return 'KEWARGANEGARAAN';
      
      return f.replace(/_id$/i, '').replace(/_/g, ' ').toUpperCase();
    }
  },
};
</script>

<style scoped>
.skeleton {
  background-color: #e2e2e2;
  border-radius: 4px;
  animation: shimmer 1.5s infinite linear;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 1200px 100%;
}

.skeleton-label {
  width: 150px;
  height: 12px;
  margin-bottom: 6px;
}

.skeleton-value {
  width: 200px;
  height: 18px;
  margin-bottom: 16px;
}

.skeleton-button {
  width: 200px;
  height: 40px;
  border-radius: 6px;
  margin-top: 20px;
}

@keyframes shimmer {
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}

/* Animasi loading */
@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  width: max-content;
  background-color: #333;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 6px 10px;
  position: absolute;
  z-index: 1;
  bottom: 120%; /* posisi di atas tombol */
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
}

.tooltip-wrapper.show-tooltip:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.custom-btn-modal {
  background-color: #00A1CA;
  color: white;
  border-radius: 10px;
  padding: 10px 25px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease;
  font-weight: 600;
  font-size: 16px;
}

.custom-btn-modal:disabled {
  background-color: #cccccc;
  color: #666666;
  cursor: not-allowed;
}
.error-text {
  color: red;
  font-size: 13px;
  margin-top: 5px;
}
.input-style {
  font-size: 18px;
  background-color: #ffffff;
  border: 1px solid #6c6d70;
  border-radius: 10px;
  margin-top: 20px;
  padding: 10px;
  width: 80%;
  text-align: center;
}
.modal-action-buttons {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 30px;
}
.modal-action-buttons.no-rekening {
  display: flex;
  justify-content: space-between; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
.modal-action-buttons.wrong-modal {
  display: flex;
  justify-content: center; /* Rata tengah */
  width: 100%;
  gap: 20px; /* Jarak antar tombol */
  margin-top: 20px;
  padding: 0 60px;
}
.custom-btn {
  background-color: #00A1CA;
  color: white !important;
  padding: 1rem 2rem !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  font-size: 20px !important;
  transition: background-color 0.3s ease;
}

.custom-btn.primary:disabled,
.custom-btn.primary[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.custom-btn.danger:disabled,
.custom-btn.danger[disabled] {
  background-color: #cccccc !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}
.custom-btn.rekening {
  background-color: #00A1CA;
  color: white !important;
  padding: 0.5rem 1.5rem !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 400;
  cursor: pointer;
  min-width: 120px;
  text-align: center;
  font-size: 20px !important;
  transition: background-color 0.3s ease;
}

.custom-btn:hover {
  background-color: #008bb0;
}

.custom-btn.primary {
  background-color: #00A1CA;
}

.custom-btn.danger {
  background-color: #00A1CA;
}

.detail-product-card {
  padding: 25px 30px;
  border: 1px solid #6c6d70;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 100%;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.gap-label {
  gap: 20px;
}

.text-label {
  font-size: 20px;
  text-transform: uppercase;
  color: #13346c;
  font-weight: 500;
}

.title-modal{
  font-size: 20px;
  color: #274C8E;
  font-weight: 500;
}

.text-value {
  font-size: 18px;
  color: #6c6d70;
  font-weight: 400;
}

.button-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.button-blue {
  padding: 15px 25px;
  background-color: #00a1ca;
  color: white;
  font-weight: 500;
  transition: all 0.5s;
  border: none;
  border-radius: 50px;
  font-size: 18px;
  width: fit-content;
  margin: 35px auto;
}

.button-blue:hover {
  transform: scale(105%);
}

/* Responsive untuk tablet & HP */
@media (max-width: 1024px) {
  .input-style {
  font-size: 18px;
  background-color: #ffffff;
  border: 1px solid #6c6d70;
  border-radius: 10px;
  padding: 7px;
}
  .text-label {
    font-size: 12px;
  }

  .text-value {
    font-size: 18px;
  }

  .button-blue {
    font-size: 16px;
  }
  .skeleton {
  background-color: #e2e2e2;
  border-radius: 4px;
  animation: shimmer 1.5s infinite linear;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 1200px 100%;
}

.skeleton-label {
  width: 150px;
  height: 12px;
  margin-bottom: 6px;
}

.skeleton-value {
  width: 200px;
  height: 18px;
  margin-bottom: 16px;
}

.skeleton-button {
  width: 200px;
  height: 40px;
  border-radius: 6px;
  margin-top: 20px;
}

@keyframes shimmer {
  0% {
    background-position: -1200px 0;
  }
  100% {
    background-position: 1200px 0;
  }
}

}
</style>


// WEBPACK FOOTER //
// src/public/component-detail-deposito-tabungan/CardInfoTabungan.vue